import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddProfessionalProfiles, ProfessionalProfiles } from '../models/ProfessionalProfiles/ProfessionalProfiles';



@Injectable({
  providedIn: 'root'
})
export class ProfessionalProfilesService {

  constructor(
    private _http: HttpClient
  ) { }

    public getProfessional(ProfessionalId?: number): Observable<ProfessionalProfiles[]>{
        return this._http.get<ProfessionalProfiles[]>(`${environment.api.url}/ProfessionalProfiles?ProfessionalProfilesId=${ProfessionalId??''}`);
    }
  
    public deleteProfessional(ProfessionalId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/ProfessionalProfiles/${ProfessionalId}`);
    }
  
    public addProfessional(model: AddProfessionalProfiles): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/ProfessionalProfiles`, model);
    }
}
